import CardCredentialDeclinedScreen from 'features/cardManagement/screens/cardCredentialChallenge/CardCredentialDeclinedScreen/CardCredentialDeclinedScreen';
import React from 'react';

export default function ProgressTrackerP2PCardCredentialDeclinedPage() {
  return <CardCredentialDeclinedScreen />;
}
